/**
 * Analytics Event Names
 * Use these constants when logging events to ensure consistency
 */
export const ANALYTICS_EVENTS = {
  // App Lifecycle
  APP_OPENED: 'app_opened',
  
  // Auth Events
  LOGIN: 'login',
  SIGN_UP: 'sign_up',
  LOGOUT: 'logout',
  USER_AUTH_ASSOCIATION: 'user_auth_association',
  SIGNUP_STARTED: 'signup_started',
  SIGNUP_SUCCEEDED: 'signup_succeeded',
  SIGNUP_FAILED: 'signup_failed',
  LOGIN_STARTED: 'login_started',
  LOGIN_SUCCEEDED: 'login_succeeded',
  LOGIN_FAILED: 'login_failed',
  
  // Navigation Events
  SCREEN_VIEW: 'screen_view',
  PAGE_VIEWED: 'page_viewed',
  
  // Action Events
  BUTTON_CLICK: 'button_click',
  UI_CLICKED: 'ui_clicked',
  FORM_SUBMIT: 'form_submit',
  SHARE: 'share',
  SEARCH: 'search',
  
  // Feature Specific Events
  CHAT_OPENED: 'chat_opened',
  MESSAGE_SENT: 'message_sent',
  EVENT_VIEWED: 'event_viewed',
  EVENT_JOINED: 'event_joined',
  EVENT_CREATED: 'event_created',
  PAYMENT_STARTED: 'payment_started',
  PAYMENT_COMPLETED: 'payment_completed',
  SUBSCRIPTION_VIEWED: 'subscription_viewed',
  SUBSCRIPTION_PURCHASED: 'subscription_purchased',

  // Event Signup / Booking Funnel
  EVENT_PAGE_VIEWED: 'event_page_viewed',
  EVENT_SIGNUP_STARTED: 'event_signup_started',
  EVENT_DATE_PICKER_VIEWED: 'event_date_picker_viewed',
  EVENT_DATE_SELECTED: 'event_date_selected',
  EVENT_CHECKOUT_VIEWED: 'event_checkout_viewed',
  EVENT_PAYMENT_STARTED: 'event_payment_started',
  EVENT_PAYMENT_SUCCEEDED: 'event_payment_succeeded',
  EVENT_PAYMENT_FAILED: 'event_payment_failed',
  EVENT_SIGNUP_COMPLETED: 'event_signup_completed',
  EVENT_SIGNUP_ABANDONED: 'event_signup_abandoned',
};

/**
 * Analytics Parameter Names
 */
export const ANALYTICS_PARAMS = {
  // Mandatory Fields
  ANONYMOUS_USER_ID: 'anonymous_user_id',
  CUSTOMER_ID: 'customer_id',
  SESSION_ID: 'session_id',
  CLICKSTREAM_ID: 'clickstream_id',
  PLATFORM: 'platform',
  TIMESTAMP: 'timestamp',
  REFERRER: 'referrer',
  REF_MARKER: 'ref_marker',
  
  // Contextual Fields
  SCREEN_NAME: 'screen_name',
  PAGE_NAME: 'page_name',
  ELEMENT_NAME: 'element_name',
  SCREEN_CLASS: 'screen_class',
  AUTH_METHOD: 'auth_method',
  ERROR_CODE: 'error_code',
  ITEM_ID: 'item_id',
  ITEM_NAME: 'item_name',
  CONTENT_TYPE: 'content_type',
  METHOD: 'method',
  SUCCESS: 'success',
  ERROR_MESSAGE: 'error_message',

  // Event Funnel Specific Fields
  EVENT_ID: 'event_id',
  EVENT_TYPE: 'event_type',
  SELECTED_DATE: 'selected_date',
  PRICE: 'price',
  CURRENCY: 'currency',
  AMOUNT_PAID: 'amount_paid',
  LAST_STEP: 'last_step',
  PAYMENT_METHOD: 'payment_method',
};
